import React from "react";
import TemplateView from "../../TemplateView";

function View(props) {
    return (
        <TemplateView
            group="User"
            subgroup="Pengaturan"
        />
    );
};

export default View;